import APIClient from '@/shared/http/clients/api'

const resourceName = 'valor-km'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=tipoTransporte,asc&size=500`, data, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?inactive=0&sort=tipoTransporte,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Search = (date = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?data=${date}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}`, data, config)

const EventTypeRepository = {
  GetAll,
  GetAllActive,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Search,
  ChangeStatus
}

export default EventTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/kmvalue.js